<template>
  <div>
    <div class="columns is-multiline">
      <div
        v-for="item in news"
        v-bind:key="item.id"
        class="column is-6 is-3-widescreen"
      >
        <a :title="item.title" :href="item.permalink" class="article">
          <div class="article__image">
            <div
              class="hover"
              :style="`background-image: url('${theme}')`"
            ></div>
            <img
              :src="item.thumbnails.lz"
              :data-src="item.thumbnails.lg"
              :data-srcset="`${item.thumbnails.md} 768w, ${item.thumbnails.lg} 992w`"
              :alt="item.article_title"
              class="lazyload blur-up"
              v-if="item.has_thumbnail"
            />
          </div>
          <p class="article__subtitle" v-html="item.tagline"></p>
          <h3 class="article__title" v-html="item.title"></h3>
        </a>
      </div>
    </div>
    <div class="loadmore" v-if="!isLoading && !reachedEnd">
      <button @click="loadMore($event)" class="button normal">
        <span v-html="more"></span>
      </button>
    </div>
    <div class="theend" v-if="reachedEnd">
      <p v-html="end"></p>
    </div>
    <div v-if="isLoading" class="columns is-multiline is-loading">
      <div
        v-bind:class="{ 'is-active': firstLoad }"
        class="column is-6 is-3-widescreen"
      >
        <div class="news__inner">
          <div class="skeleton-load animated"></div>
        </div>
      </div>
      <div class="column is-6 is-3-widescreen">
        <div class="news__inner">
          <div class="skeleton-load animated"></div>
        </div>
      </div>
      <div class="column is-6 is-3-widescreen">
        <div class="news__inner">
          <div class="skeleton-load animated"></div>
        </div>
      </div>
      <div class="column is-6 is-3-widescreen">
        <div class="news__inner">
          <div class="skeleton-load animated"></div>
        </div>
      </div>
      <div class="column is-6 is-3-widescreen">
        <div class="news__inner">
          <div class="skeleton-load animated"></div>
        </div>
      </div>
      <div class="column is-6 is-3-widescreen">
        <div class="news__inner">
          <div class="skeleton-load animated"></div>
        </div>
      </div>
      <div class="column is-6 is-3-widescreen">
        <div class="news__inner">
          <div class="skeleton-load animated">.</div>
        </div>
      </div>
      <div v-if="!firstLoad" class="column is-6 is-3-widescreen">
        <div class="news__inner">
          <div class="skeleton-load animated">.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global wpApiSettings */
/* global gameOver */
/* global loadMore */
import axios from "axios";

export default {
  data() {
    return {
      api: wpApiSettings.root,
      theme:
        wpApiSettings.url + "/wp-content/themes/zigt/public/img/hover-z.svg",
      isLoading: true,
      firstLoad: true,
      news: [],
      posts_per_page: 7,
      offset: 0,
      end: gameOver,
      more: loadMore,
      reachedEnd: false,
    };
  },
  methods: {
    loadNews() {
      this.isLoading = true;
      axios
        .get(`${this.api}news/v1/list/`, {
          params: {
            timestamp: Date.now(),
            offset: this.offset,
            posts_per_page: this.posts_per_page,
          },
        })
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((element) => {
              this.news.push(element);
            });
            this.offset = this.offset + this.posts_per_page;

            if (response.data.length < this.posts_per_page) {
              this.reachedEnd = true;
            }
          } else {
            this.reachedEnd = true;
          }

          if (this.firstLoad) {
            this.firstLoad = false;
            this.posts_per_page = 8;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    loadMore(e) {
      e.preventDefault();
      this.loadNews();
    },
  },
  mounted() {
    this.loadNews();
  },
};
</script>
